import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=642caebc&scoped=true&lang=html&"
import script from "./rating.vue?vue&type=script&lang=js&"
export * from "./rating.vue?vue&type=script&lang=js&"
import style0 from "./rating.vue?vue&type=style&index=0&id=642caebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642caebc",
  null
  
)

export default component.exports